import { yatPageSlice } from './yat-page';

export const {
    setYatPage,
    setEmptyYatPage,
    setYatPageLiquidIdItemsPersisted,
    setYatPagePaging,
    setIsYatPageOwner,
    setYatPageVersion,
    setIsLoadingItems,
    setYatPageHeading,
    setYatPageBio,
    addLiquidIDItem,
    setDraggingLiquidIDThumbnail,
    setYatPageLiquidID,
    setLiquidIdLoading,
    setLiquidIdEditStage,
    stageLiquidIDItem,
    addStagedLiquidIDItem,
    reorderLiquidID,
    setLiquidIDExpandedPreview,
    setLiquidIDVisibleFace,
    setLiquidIDFaceSelection,
    setYatPageDragging,
    setYatPageEditingItem,
    setYatPagePreviewItem,
    updateYatPageEditStates,
    addYatPageItem,
    addYatPageBulkItems,
    updateYatPageItem,
    updateYatPageItemsOrder,
    removeYatPageItem,
    removeYatPageBulkItems,
    replaceAssetTempId,
    publishYatPage,
    updateExternalLayout,
    removeModifiedStatus,
    setYatPageAssets,
    removeYatPageModifiedItem,
    updateAutoProfile,
    removeInvalidLink,
} = yatPageSlice.actions;

export const { reducer: yatPageReducer } = yatPageSlice;
export { PublishState } from './types';
export type { YatPageState, PageAssets } from './types';
